import { ReactElement } from "react";

import "../collection/collections.css";
import CollectionsProvider from "../../providers/collections-provider";
import CollectionsList from "../../sections/collections/collections-list";
import CollectionsNavigation from "../../sections/collections/collections-navigation";
import LeftNavigation from "../collection/parts/left-navigation/left-navigation";

export default function Collections(): ReactElement {
  return (
    <CollectionsProvider>
      <CollectionsNavigation />
      <div className="flex w-full flex-row gap-[25px]">
        <div className="basis-[320px] shrink-0">
          <LeftNavigation />
        </div>
        <CollectionsList />
      </div>
    </CollectionsProvider>
  );
}
